import React from 'react';
import PropTypes from 'prop-types';

class SingleStockist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      expandClasses: 'stockist__expand',
      contentClasses: 'stockist__content',
    };

    this.handleClickEvent = this.handleClickEvent.bind(this);
  }

  handleClickEvent() {
    const { active } = this.state;

    if (active) {
      this.setState({
        active: false,
        expandClasses: 'stockist__expand',
        contentClasses: 'stockist__content',
      });
    } else {
      this.setState({
        active: true,
        expandClasses: 'stockist__expand stockist__expand--active',
        contentClasses: 'stockist__content stockist__content--active',
      });
    }
  }

  render() {
    const { expandClasses, contentClasses } = this.state;
    const { stockist, distance, icons } = this.props;
    const hasPromo1 = stockist.promo1ImgUrl || false;
    const hasPromo2 = stockist.promo2ImgUrl || false;
    const promoClasses =
      stockist.promo1ImgUrl && stockist.promo2ImgUrl
        ? 'stockist__promo-banner stockist__promo-banner--half'
        : 'stockist__promo-banner';

    return (
      <div className='stockist'>
        <div className='stockist__header' onClick={this.handleClickEvent}>
          <div className='stockist__header-half'>
            <div>
              <span
                className='stockist__type-icon'
                dangerouslySetInnerHTML={{ __html: icons[stockist.type] }}
              ></span>
              <span>{stockist.name}</span>
            </div>
          </div>
          <div className='stockist__header-half'>
            <span className='hide-sm'>
              {stockist.lat && stockist.lng && distance !== '-10'
                ? `${distance}km`
                : null}
            </span>
            <div>
              <div className='stockist__icons-group'>
                {stockist.mobileOnly === 'yes' && (
                  <span
                    dangerouslySetInnerHTML={{ __html: icons.mobile }}
                  ></span>
                )}
                {stockist.saddleFitter === 'yes' && (
                  <span
                    dangerouslySetInnerHTML={{ __html: icons.saddleFitter }}
                  ></span>
                )}
                {stockist.onlineOnly === 'yes' && (
                  <span
                    dangerouslySetInnerHTML={{ __html: icons.onlineOnly }}
                  ></span>
                )}
                {stockist.promo1ImgUrl !== '' && (
                  <span
                    dangerouslySetInnerHTML={{ __html: icons.promo1 }}
                  ></span>
                )}
                {stockist.promo2ImgUrl !== '' && (
                  <span
                    dangerouslySetInnerHTML={{ __html: icons.promo2 }}
                  ></span>
                )}
              </div>
              <div className={expandClasses}>
                <span className='stockist__open'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                  >
                    <path fill='#8d9794' d='M4.5 10h11v1h-11z' />
                  </svg>
                </span>
                <span className='stockist__closed'>
                  <svg
                    id='Layer_1'
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                  >
                    <g id='Group' transform='translate(5 5)'>
                      <path
                        className='st0'
                        d='M-.5 5h11v1h-11z'
                        id='Line-4-Copy'
                      />
                      <path className='st0' d='M4.5 0h1v11h-1z' />
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className={contentClasses}>
          <div className='stockist__content-wrapper'>
            <div className='stockist-content__half'>
              <span>{stockist.phone}</span>
              <span>{stockist.email}</span>
              <span>{stockist.website}</span>
            </div>
            <div className='stockist-content__half'>
              <span className='medium-up--hide stockist__distance'>
                {distance}km
              </span>
              <span>{stockist.address}</span>
              <span>
                {stockist.province}
                {stockist.province && stockist.state ? ',' : ''}{' '}
                {stockist.state} {stockist.zip}
              </span>
              <span>{stockist.country}</span>
              {stockist.lat && stockist.lng ? (
                <div className='stockist__directions'>
                  <a
                    href={`http://www.google.com/maps/place/${stockist.lat},${stockist.lng}`}
                    className='btn--text'
                    target='_blank'
                  >
                    Get Directions{' '}
                    <svg
                      aria-hidden='true'
                      focusable='false'
                      className='icon icon-arrow-small-right'
                      width='20'
                      height='20'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='m8 14.7-.7-.7 4-4-4-4 .7-.7 4.7 4.7z'
                        fill='#000000'
                      />
                    </svg>
                  </a>
                </div>
              ) : null}
            </div>
          </div>

          {distance !== '-10' && (
            <div className='stockist__promo-wrapper'>
              {hasPromo1 && (
                <div className={promoClasses}>
                  <a href={stockist.promo1Url}>
                    <img src={stockist.promo1ImgUrl} />

                    <div className='stockist__promo-desc h3'>
                      {stockist.promo1Title}
                    </div>
                  </a>
                </div>
              )}
              {hasPromo2 && (
                <div className={promoClasses}>
                  <a href={stockist.promo2Url}>
                    <img src={stockist.promo2ImgUrl} />

                    <div className='stockist__promo-desc h4'>
                      {stockist.promo2Title}
                    </div>
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

SingleStockist.propTypes = {
  stockist: PropTypes.object,
  distance: PropTypes.string,
  icons: PropTypes.object,
};

export default SingleStockist;
